import { useSyncExternalStore } from 'react';

/**
 * The product has one breakpoint: below it the sidebar is gone and the bottom
 * bar is showing, so the screen is a phone and list screens render as cards
 * instead of tables. Kept in sync by hand with the `@media` blocks in app.css.
 */
const PHONE = '(max-width: 767px)';

const subscribe = (onChange: () => void) => {
  const query = window.matchMedia(PHONE);
  query.addEventListener('change', onChange);
  return () => query.removeEventListener('change', onChange);
};

export function useIsPhone(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(PHONE).matches,
    // No window on the server; the desktop table is the safer first paint.
    () => false,
  );
}
